module.exports = __webpack_public_path__ + "assets/peopleCommunity.07be39f8.svg";